import help from './assets/images/help.png';
import home from './assets/images/home.png';
import q1 from './assets/images/q1.png';
import q2 from './assets/images/q2.png';
import coriolisLogoDark from './assets/logos/coriolis-logo-dark.png';
import coriolisLogoDarkWide from './assets/logos/coriolis-logo-dark-wide.png';
import coriolisLogoWhite from './assets/logos/coriolis-logo-light.png';
import coriolisLogoWhiteWide from './assets/logos/coriolis-logo-light-wide.png';

import evoLogoWhite from './assets/logos/EvoESG-white.png';
import evoLogoBlack from './assets/logos/EvoESG-blk.png';

import businessFunctionsOff from './assets/images/business-functions-off.png';
import businessFunctionsOn from './assets/images/business-functions-on.png';
import companyOff from './assets/images/company-off.png';
import companyOn from './assets/images/company-on.png';
import financesOff from './assets/images/finances-off.png';
import financesOn from './assets/images/finances-on.png';
import paperOff from './assets/images/paper-off.png';
import paperOn from './assets/images/paper-on.png';
import regulationOff from './assets/images/regulation-off.png';
import regulationOn from './assets/images/regulation-on.png';
import computer from './assets/images/computer.png';
import landing from './assets/images/landing.png';
import score from './assets/images/score.png';

import atlasLogoWhite from './assets/svg/atlas-landscape-white.svg';
import logo from './assets/svg/atlas-landscape.svg';
import paperSvg from './assets/svg/paper.svg';
import kitemarkFrame from './assets/svg/kitemark-frame.svg';
import kitemark from './assets/svg/kitemark.svg';
import kitemarkIcon from './assets/svg/kitemark-icon.svg';
import { ReactComponent as CompanySvg } from './assets/svg/company.svg';
import { ReactComponent as SustainabilitySvg } from './assets/svg/sustainability.svg';
import { ReactComponent as FinanceSvg } from './assets/svg/finances.svg';
import { ReactComponent as BusinessFunctionSvg } from './assets/svg/business-functions.svg';

import error404 from './assets/images/404.png';
import error500 from './assets/images/500.png';

type Status = 'On' | 'Off';
/* eslint-disable @typescript-eslint/no-unsafe-return */
const iconGenerator = (name: string, status: Status): string => {
  const mapper = {
    businessFunctionsOff,
    businessFunctionsOn,
    companyOff,
    companyOn,
    financesOff,
    financesOn,
    paperOff,
    paperOn,
    regulationOff,
    regulationOn,
  };
  if (['On', 'Off'].includes(status)) {
    return mapper[`${name}${status}`];
  } else {
    return help;
  }
};

export {
  CompanySvg,
  BusinessFunctionSvg,
  FinanceSvg,
  SustainabilitySvg,
  computer,
  coriolisLogoWhite,
  coriolisLogoDark,
  coriolisLogoWhiteWide,
  coriolisLogoDarkWide,
  evoLogoWhite,
  evoLogoBlack,
  help,
  home,
  iconGenerator,
  kitemark,
  kitemarkFrame,
  kitemarkIcon,
  landing,
  atlasLogoWhite,
  logo,
  q1,
  q2,
  score,
  error404,
  error500,
  paperSvg,
};
